import { parse } from 'yaml';

/**
 * Service for loading and parsing YAML files
 */
export class YamlService {
  /**
   * Loads a YAML file from the given path
   * @param filename The name of the YAML file to load
   * @returns The parsed YAML data
   */
  static async loadYamlFile(filename: string): Promise<any> {
    try {
      const response = await fetch(`/data/${filename}`);
      if (!response.ok) {
        throw new Error(`Failed to load YAML file: ${filename}`);
      }
      const yamlText = await response.text();
      return parse(yamlText);
    } catch (error) {
      console.error('Error loading YAML file:', error);
      throw error;
    }
  }

  /**
   * Gets a list of available YAML files
   * @returns Array of YAML filenames
   */
  static async getAvailableFiles(): Promise<string[]> {
    // This would need a backend endpoint to list files
    // For now, we'll return a hardcoded list of known files
    return [
      '1_internship.yaml',
      '1_internship_new.yaml',
      '2_thesis_external.yaml',
      '2_thesis_external_new.yaml',
      '3_thesis_eth_external.yaml',
      '3_thesis_eth_external_new.yaml',
      '4_project_student_job.yaml',
      '5_project_based_learning.yaml',
      '6_technology_challenge.yaml',
      '7_feasibility_lab.yaml',
      '_workflow_items.yaml',
    ];

    // Catch block is unreachable with the current implementation
    // Better to remove it until we implement the actual file listing
  }
}
